import { Serializable } from '../../../core/models/serializable';

export class SuspendedEmailAddress
  implements Serializable<SuspendedEmailAddress>
{
  fromObject(object: any): SuspendedEmailAddress {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  suspendedEmailAddressId: number;
  emailAddress: string;

  suspendType: string;
  bounceType: string;
  bounceSubType: string;

  complaintType: string;

  jobseekerId: number;
  customerAgentId: number;
  subscriberId: number;
  isHighlighted: boolean;
}
